module.exports = __webpack_public_path__ + "ac087a6b53677306905e24bc49d8dbcd.png";